import Vue from 'vue'
import Router from 'vue-router'
import ShopMenu from '@/views/ShopMenu'
import Order from '@/views/Order'
import Advertisement from '@/views/Advertisement'
import Search from '@/views/Search'
import Check from '@/views/selfcheck/Check'
import CheckConfirm from '@/views/selfcheck/CheckConfirm'
import DishesConfirm from '@/views/selfcheck/DishesConfirm'
import TotalAmount from '@/views/selfcheck/TotalAmount'
import SelfcheckReload from '@/views/selfcheck/SelfcheckReload'
import ErrorPage from '@/views/ErrorPage'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior(_to_, _from_, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'shopMenu',
      component: ShopMenu,
    },
    {
      path: '/order/:id',
      name: 'order',
      component: Order,
      meta: {
        influxType: 0,
      },
    },
    {
      path: '/ad/:adId/',
      name: 'ad',
      component: Advertisement,
    },
    {
      path: '/ad/:adId/order/:id',
      name: 'adOrder',
      component: Order,
      meta: {
        influxType: 1,
      },
    },
    {
      path: '/recommend/:fromId/order/:id',
      name: 'recommendOrder',
      component: Order,
      meta: {
        influxType: 2,
      },
    },
    {
      path: '/history',
      name: 'history',
      component:
        process.env.VUE_APP_TYPE === 'app'
          ? () => import(/* webpackChunkName: "history" */ '@/views/History')
          : () => import(/* webpackChunkName: "history-web" */ '@/views/HistoryWeb'),
    },
    {
      path: '/history/:historyId/order/:id',
      name: 'historyOrder',
      component: Order,
      meta: {
        influxType: 3,
      },
    },
    {
      path: '/search',
      name: 'search',
      component: Search,
    },
    {
      path: '/search/order/:id',
      name: 'searchOrder',
      component: Order,
      meta: {
        influxType: 4,
      },
    },
    {
      path: '/selfcheck/totalAmount',
      name: 'totalAmount',
      component: TotalAmount,
    },
    {
      path: '/selfcheck/checkConfirm',
      name: 'checkConfirm',
      component: CheckConfirm,
    },
    {
      path: '/selfcheck/dishesConfirm',
      name: 'dishesConfirm',
      component: DishesConfirm,
    },
    {
      path: '/selfcheck/check',
      name: 'check',
      component: Check,
    },
    {
      path: '/selfcheck/reload',
      name: 'selfcheckReload',
      component: SelfcheckReload,
    },
    {
      path: '*',
      name: 'errorPage',
      component: ErrorPage,
    },
  ],
})

export default router
